import { gql } from "@apollo/client";

export const CREATE_PACKAGE_PRICE = gql`
mutation CreatePackagePrice($input: PackagePriceInput) {
  createPackagePrice(input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const UPDATE_PACKAGE_PRICE = gql`
mutation UpdatePackagePrice($id: ID!, $input: PackagePriceInput) {
  updatePackagePrice(_id: $id, input: $input) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const DELETE_PACKAGE_PRICE = gql`
mutation DeletePackagePrice($id: ID!) {
  deletePackagePrice(_id: $id) {
    isSuccess
    message {
      messageKh
      messageEn
    }
  }
}
`;

export const GET_PACKAGE_PRICE_PAGINATION = gql`
query GetPackagePricePagination($page: Int, $limit: Int, $pagination: Boolean, $keyword: String, $classId: String, $groupFeeId: String) {
  getPackagePricePagination(page: $page, limit: $limit, pagination: $pagination, keyword: $keyword, classId: $classId, groupFeeId: $groupFeeId) {
    data {
      _id
      title
      unlimited
      classId {
        _id
        className
        courseId {
          _id
          khName
          enName
          totalHour
          remark
        }
        duration
        shiftId {
          _id
          khName
          enName
          remark
        }
        totalHour
        totalLesson
        totalStudent
      }
      groupFeeId {
        _id
        type
        title
        price
        remark
      }
      duration
      discountType
      discountAmount
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;